import { handleActions } from 'redux-actions';
import immutable from 'object-path-immutable';
import * as actions from './actions';
import { readModeratorMode } from './actions';

const defaultState = {
  currentUser: null,
  currentUserInfo: null,
  // { isAdmin, isModerator } from the API at sign-in; kept apart from
  // currentUserInfo, which profile edits replace.
  currentUserRoles: null,
  // The sidebar toggle; only has an effect for admins/moderators.
  moderatorMode: readModeratorMode(),
  authChecking: true,
  authCheckError: null,
  isSessionLoaded: false,
};

const authUserReducer = handleActions(
  new Map([
    [actions.sessionLoadRequest,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: true,
          authCheckError: null
        });
      }],
    [actions.sessionLoadSuccess,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: false,
          authCheckError: null,
          currentUser: action.payload.user,
          currentUserInfo: action.payload.info,
          currentUserRoles: action.payload.roles || null,
          isSessionLoaded: true
        });
      }],
    [actions.sessionLoadFailed,
      (state, action) => {
        return Object.assign({}, state, {
          authChecking: false,
          authCheckError: action.payload,
          currentUser: null,
          currentUserInfo: null,
          currentUserRoles: null,
          isSessionLoaded: true
        });
      }],

    [actions.moderatorModeChanged,
      (state, action) => {
        return Object.assign({}, state, { moderatorMode: !!action.payload });
      }],

    [actions.setCurrentUserInfo,
      (state, action) => {
        return immutable.set(state, 'currentUserInfo', action.payload);
      }],

  ]),
  defaultState
);

export default authUserReducer;